import React, { useEffect } from 'react'
import StarRating from '../StarRating/StarRating'
import styles from '../../tabs/review/RequestForReviews/RequestForReviews.module.scss'

function ReviewsQuestion({ title, answer, id, handleClick, isEditable = true }) {
  const [rating, setRating] = React.useState(answer)
  const [hoverRating, setHoverRating] = React.useState(0)

  const onMouseEnter = (index) => {
    if (isEditable) {
      setHoverRating(index)
    }
  }
  const onMouseLeave = () => {
    if (isEditable) {
      setHoverRating(0)
    }
  }
  const onSaveRating = (index) => {
    if (isEditable) {
      setRating(index)
    }
  }

  useEffect(() => {
    if (isEditable && handleClick) {
      handleClick(rating, id)
    }
  }, [rating, id, handleClick, isEditable])

  return (
    <li>
      <div className={styles.question}>{title}</div>
      <div>
        <StarRating
          rating={rating}
          hoverRating={hoverRating}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onSaveRating={onSaveRating}
          size='21px'
          disabled={!isEditable}
        />
      </div>
    </li>
  )
}

export default ReviewsQuestion
